<template>
  <div class="container">
    <one-line-form v-if="!showOneLineAddress" :submit="updatePostalCode" :submittable="isValid" :saving="isSaving ? postalCode : ''" :loading="true">
      <input-field name="zip"
                  id="tel"
                   :class="{ invisible: isSaving, uppercase: true, disabled: noPostcodeEntry }"
                   type="text"
                   :title="noCodeCountry ? '' : i18n.t('postalCode:postcode', { context: appCountry })"
                   :placeholder="customPlaceholder || i18n.t('postalCode:enter_postcode', { context: appCountry })"
                   :value="postalCode"
                   @maskInput="syncPostalCode"
                   v-mask="postalCodePattern"
                   :autocapitalize="true"
                   :autocorrect="false"
                   :autocomplete="'postal-code'"
                   v-show="!containsLetters"
                   v-keyboard="'tel'"
                   :disabled="noPostcodeEntry"
                   :cleanRegExp="new RegExp(/\s+$/)" />
      <input-field name="zip2"
                  id="alphanumeric"
                   :class="{ invisible: isSaving, uppercase: true, disabled: noPostcodeEntry }"
                   type="text"
                   :title="noCodeCountry ? '' : i18n.t('postalCode:postcode')"
                   :placeholder="customPlaceholder || i18n.t('postalCode:enter_postcode')"
                   :value="postalCode"
                   @maskInput="syncPostalCode"
                   v-mask="canShowSpecificContent ? postalCodePattern : '####################'"
                   :autocapitalize="true"
                   :autocorrect="false"
                   :autocomplete="'postal-code'"
                   v-show="containsLetters"
                   v-keyboard="'alphanumeric'"
                   :disabled="noPostcodeEntry"
                   :cleanRegExp="new RegExp(/\s+$/)" />
      <p class="hint countryprompt" v-show="!isSaving && canShowSpecificContent" :class="{disabled: !isCountryChangeAvailable}"   @click="openCountrySelect">{{ getLocalCountryName(app.country.code, i18n) }}</p>
      <helper v-show="isBlockedPostalCode" class="blocked-postal">{{ i18n.t(`postalCode:blocked_postal`) }}</helper>
    </one-line-form>
    <one-line-address v-else :screenParams="screenParams">
      <p class="hint countryprompt" v-show="!isSaving" :class="{disabled: !isCountryChangeAvailable}"   @click="openCountrySelect">{{ getLocalCountryName(app.country.code, i18n) }}</p>
    </one-line-address>
    <helper v-show="isSaving && !showOneLineAddress" class="verification-indicator">{{ i18n.t('base:verifying') }}</helper>
    <helper v-show="askIfForgot && !noPostcodeEntry && !isSaving && !showOneLineAddress" :questions="true" :class="{ postcode: true, android: app.deviceIsAndroid}"><a @click="approvePostcode('forgot')">{{ i18n.t('postalCode:dont_remember') }}</a></helper>


    <option-selector  v-if="showCountryModal" is-overlay  :options="getCountriesOptions" @submit="selectCountry" @close="showCountryModal = false" ></option-selector>
    <show-keyboard v-if="!noCodeCountry && !showCountryModal && !showOneLineAddress" :focus-element="input"></show-keyboard>
  </div>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/mixins';

  /deep/ .list-container {
      @import '../assets/country-flags';
  }

  .container {
    width: 100%;
    @include tablet {
      width: $tablet-content-width;
    }
  }

  .postcode {
    text-align: right;
    margin-top: 50px;

    a {
      font-size: $inputLinkSize;
      font-size: $inputLinkSize-portal;
      color: $inputLinkColor;
      color: $inputLinkColor-portal;
      font-weight: $inputLinkWeight;
      font-weight: $inputLinkWeight-portal;
      text-decoration: underline;
    }
  }
  .countryprompt{
      &::after{
          content: ' ';
          background-image: url('~static/dropdown.svg');
          background-repeat: no-repeat;
          height: 6px;
          width: 10px;
          position: relative;
          display: inline-block;
          margin-left: 8px;
      }
      &.disabled::after{
        display: none;
      }
  }

  .android {
    padding-bottom: 0;

    a {
      padding-top: 20px;
    }
  }

  ins {
    color: transparent;
    background: #FFF200;
    display: inline-block;
    position: relative;

    i {
      background: no-repeat left 9px;
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDBweCIgaGVpZ2h0PSIyN3B4IiB2aWV3Qm94PSIwIDAgNDAgMjciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQyICgzNjc4MSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+d2FybmluZy1hcnJvdzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJ3YXJuaW5nLWFycm93IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIiBzdHJva2U9IiNGRkIzMDAiPgogICAgICAgICAgICA8cGF0aCBkPSJNMzguNTg0OTYwOSwwIEMyMy41MTU1MTY1LDAgNy40NzM4NDk4Myw4LjE3MzA3NjkyIDMuNTg0OTYwOTQsMjUiIGlkPSJQYXRoLTIiPjwvcGF0aD4KICAgICAgICAgICAgPHBhdGggZD0iTTMuNDM2NTIzNDQsMjUuNTYzNDc2NiBDMi4yOTEwMTU2MiwyMS4wNzA2MzggMS4xNDU1MDc4MSwxNi41Nzc3OTk1IDAsMTIuMDg0OTYwOSIgaWQ9IlBhdGgtMyI+PC9wYXRoPgogICAgICAgICAgICA8cGF0aCBkPSJNMy4zNzU5NzY1NiwyNS4zNTE1NjI1IEM2LjU4NDk2MDk0LDIzIDguOTgwNDY4NzUsMjIuMTc1NzgxMiAxNC41ODQ5NjA5LDE5IiBpZD0iUGF0aC00Ij48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=');
      position: absolute;
      display: block;
      left: 50%;
      bottom: 100%;
      height: 40px;
      color: #FFB300;
      font-size: 1rem;
      font-weight: lighter;
      padding-left: 42px;
      margin-bottom: 5px;
      margin-left: -5px;
      line-height: 120%;
    }
  }

  .verification-indicator {
    font-size:16px;
    line-height: 16px;
  }

  .blocked-postal {
    margin-top: 50px !important;
    color: #EB8F06 !important;
  }
</style>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import { setSelection } from '../utils/selection'
  import { getNestedProperty, areConditionsPassed } from '../utils/structure.js'
  import Mousetrap from 'mousetrap'

  import AdditionalKeyboard from '../components/AdditionalKeyboard'
  import CharKeyboard from '../components/CharKeyboard'
  import BottomHints from '../components/BottomHints'
  import Modal from '../components/Modal'
  import Country from '../components/Country'
  import OneLineAddress from '../components/OneLineAddress.vue'

  const blockedPostals = () => import('../utils/blockedPostals')

  export default Vue.component('personal-postal-code-screen', {
    components: {
      'additional-keyboard': AdditionalKeyboard,
      'char-keyboard': CharKeyboard,
      'bottom-hints': BottomHints,
      'modal': Modal,
      'country': Country,
      'one-line-address': OneLineAddress
    },
    props: ['screenParams'],
    data () {
      const app = this.$store.state.app
      const user = this.$store.state.user
      const partner = this.$store.state.partner

      const phonePrediction = this.$store.state.phonePrediction
      const companyPrediction = this.$store.state.companyPrediction && this.$store.state.companyPrediction.matchCompany

      const dispatchKeyConditions = this.screenParams && this.screenParams.dispatchKey && this.screenParams.dispatchKey.conditions
      const dispatchKeyString = this.screenParams && this.screenParams.dispatchKey && typeof this.screenParams.dispatchKey === 'string' && this.screenParams.dispatchKey
      const dispatchKey = (dispatchKeyConditions && areConditionsPassed(this.$store, this.screenParams.dispatchKey.conditions) && this.screenParams.dispatchKey.prop) || dispatchKeyString || 'updateUser'
      const key = dispatchKey.replace('update', '').toLowerCase()

      const propertyName = (this.screenParams && this.screenParams.propertyName) || 'postalCode'

      let propertyEntity = propertyName.split('.')
      propertyEntity = propertyEntity.length > 1 ? propertyEntity.slice(0, -1).join('.') : false
      const entityData = propertyEntity ? getNestedProperty(this.$store.state[key], propertyEntity) : this.$store.state[key]

      const userPostcodePrediction = phonePrediction.enabled && phonePrediction.matchPerson.postalCode
      const companyPostcodePrediction = companyPrediction && companyPrediction.postalCode

      const postalCode = (entityData.postalCode !== app.unknownPostcode && entityData.postalCode) || (key === 'user' && userPostcodePrediction) || (key === 'company' && companyPostcodePrediction) || ''

      const showOneLineAddress = app.country.code && partner.oneInputAddressCountries && partner.oneInputAddressCountries.includes(app.country.code)
      const canShowSpecificContent = this.$store.getters.canShowSpecificContent

      return {
        title: 'Postleitzahl',
        postalCode: postalCode,
        postalCodeFormatted: null,
        rawPostalCode: null,
        GeoPostalCode: user.GeoPostalCode,
        postalCodePattern: app.country.postalCodePattern || '##########',
        appCountry: app.country.code.toLowerCase(),
        isSaving: false,
        confirmPostalCode: false,
        forgotTimeout: null,
        askIfForgot: false,
        containsLetters: false,
        showCountryModal: false,
        noPostcodeEntry: false,
        customPlaceholder: null,
        entity: entityData,
        propertyName: propertyName,
        storeKey: key,
        dispatchKey: dispatchKey,
        userLeftScreen: false,
        showOneLineAddress: showOneLineAddress || false,
        blockedPostalCodes: {},
        canShowSpecificContent
      }
    },
    watch: {
      'user.postalCode' () {
        this.postalCode = this.user.postalCode !== this.app.unknownPostcode ? this.user.postalCode : ''
      },
      'user.GeoPostalCode' () {
        this.GeoPostalCode = this.user.GeoPostalCode
      },
      'app.country.postalCodePatternString' () {
        this.syncPostalCode('')
        this.postalCodePattern = this.app.country.postalCodePattern || '##########'
      },
      'app.country.code' () {
        this.$nextTick(() => {
          this.appCountry = this.app.country.code.toLowerCase()
          this.postalCodeRequirements()
          this.focusActiveInput()
          this.checkIfOneLineAddress()
        })
      },
      isValid () {
        this.$emit('tooltip', this.isValid ? ['enter'] : ['type'])
      },
      isSaving () {
        if (this.isSaving) {
          this.$emit('tooltip', 'hide')
        }
      }
    },
    computed: {
      ...mapState(['app', 'user', 'postalArea', 'partner', 'autofill', 'l10n', 'location']),

      streetMode () {
        return !!(this.postalArea.isLoading || this.user.city)
      },
      isPostcodeValid () {
        if (this.postalCode) {
          if (this.noCodeCountry || this.app.country.singlePostalCode) {
            return true
          }

          if (!this.canShowSpecificContent) {
            return /^[A-Za-z0-9]{1,20}$/.test(this.postalCode)
          }

          let postCodeRegex = new RegExp(this.app.country.postalCodeRegex)
          return !this.isBlockedPostalCode && postCodeRegex.test(this.postalCode)
        }
      },
      isCountryChangeAvailable () {
        return this.app.supportedCountries.length
      },
      noCodeCountry () {
        return !this.app.country.singlePostalCode && !this.app.country.postalCodePattern
      },
      isBlockedPostalCode () {
        return this.shouldBlockPostalcodes ? this.getBlockedPostals && this.getBlockedPostals[this.app.country.code] && this.getBlockedPostals[this.app.country.code].includes(this.postalCode) : false
      },
      shouldBlockPostalcodes () {
        return this.customData.blockedPostalCodes !== undefined || // check if we have list from custom data
          this.customData.blockPostalCodes === true || // check if  we should block from custom data
          (this.customData.blockPostalCodes === undefined && this.partner.blockPostalCodes === true) // only use value from partner.module if no custom data
      },
      customData () {
        return this.$store.state.customData || {}
      },
      getBlockedPostals () {
        return this.customData.blockedPostalCodes ? this.customData.blockedPostalCodes : this.blockedPostalCodes
      },
      isValid () {
        return (!!this.postalCode && this.isPostcodeValid && !this.confirmPostalCode) || this.noPostcodeEntry
      },
      countries () {
        let filteredCountries = []

        for (let countryCode of this.app.supportedCountries) {
          let isRestricted = this.isRestrictedCountry(countryCode)

          if (!isRestricted) {
            // Maps country code instead of loading every country, because the selecotr uses only country code
            let country = !!this.l10n[countryCode] && {
              code: countryCode,
              name: this.getLocalCountryName(countryCode, this.i18n)
            }
            let isFeaturedCountry = this.partner.featuredCountries.indexOf(countryCode) !== -1

            if (country && country !== null && country !== undefined && !isFeaturedCountry) filteredCountries.push(country)
          }
        }

        return filteredCountries.sort(this.sortAlphebetically)
      },
      topCountries () {
        let filteredCountries = []

        for (let countryCode of this.partner.featuredCountries) {
          let isRestricted = this.isRestrictedCountry(countryCode)

          if (!isRestricted) {
            let country = !!this.l10n[countryCode] && {
              code: countryCode
            }

            if (country && country !== null && country !== undefined && country.code === this.location.countryCode) {
              filteredCountries.unshift(country)
            } else if (country && country !== null && country !== undefined) {
              filteredCountries.push(country)
            }
          }
        }

        return filteredCountries
      },
      getCountriesOptions () {
        let countries = this.countries
        let topCountries = this.topCountries.map((country) => {
          country.prepend = `<span class="flag flag-icon flag-icon-squared flag-icon-${country.code.toLowerCase()}"></span>`
          country.name = this.getLocalCountryName(country.code, this.i18n)
          country.hideBorders = true
          return country
        })

        const groupSeparator = this.i18n.t('country:group_separator_all')
        if (groupSeparator && countries.length) {
          topCountries.push({
            subheader: groupSeparator
          })
        }

        return topCountries.concat(countries).map((country) => {
            return {
              label: country.name,
              value: country.code,
              prepend: country.prepend || null,
              hideBorders: country.hideBorders || null,
              subheader: country.subheader || null
            }
        })
      }
    },
    created () {
      const restrictedCountryIsSet = this.partner.restrictedCountries && this.partner.restrictedCountries.includes(this.app.country.code)

      if (restrictedCountryIsSet) {
        this.fixCountry(this.partner.fallbackCountry)
      }

      this.postalCodeRequirements()
    },
    mounted () {
      // this.$el.querySelector('.numbarea').style.pointerEvents = 'none'
      let activeInput
      if (this.showOneLineAddress) {
        return
      } else {
        activeInput = this.containsLetters ? this.$el.querySelector('#alphanumeric input') : this.$el.querySelector('#tel input')
      }
      activeInput.addEventListener('keydown', () => {
        window.clearTimeout(this.forgotTimeout)
        this.showDelayedForgot()
      })

      this.showDelayedForgot()

      if (this.isCountryChangeAvailable) {
        Mousetrap(activeInput).bind('down', () => {
          activeInput.blur()
          this.toggleModal()
        })
      }

      this.autofillPostalCode()
      this.$store.commit('updateApp', {dropPostalCodeFetch: false})

      if (this.shouldBlockPostalcodes && this.customData.blockedPostalCodes === undefined) {
        blockedPostals().then((result) => {
          this.blockedPostalCodes = result.default
        })
      }

      this.$emit('tooltip', ['type'])
    },
    methods: {
      input () {
        return this.containsLetters ? this.$el.querySelector('#alphanumeric input') : this.$el.querySelector('#tel input')
      },
      syncPostalCode (maskedValue, rawValue) {
        if (this.usingPrefill && maskedValue !== this.postalCode) this.usingPrefill = false
        this.postalCode = maskedValue
        this.postalCodeFormatted = maskedValue
        this.rawPostalCode = rawValue || maskedValue

        if (this.entity.city && this.postalCode !== this.entity.postalCode) {
          const resetFields = ['province', 'city', 'streetName', 'houseNumber', 'door', 'floor', 'fullAddressText']
          const resetObject = {}

          resetFields.forEach(fieldPropName => {
            const property = this.propertyName.split('.')
            const resetProp = property.length > 1 ? property.slice(0, -1).join('.') + fieldPropName : fieldPropName
            resetObject[resetProp] = ''
          })

          this.$store.dispatch(this.dispatchKey, resetObject)

          if (this.dispatchKey === 'userUpdate') {
            this.$store.commit('updatePostalCodePrediction', {
              matchPerson: {}
            })
          }
        }
      },
      updatePostalCode () {
        this.isSaving = true

        this.updateCountry()

        let dispatchData = {}
        const property = this.propertyName.split('.')
        dispatchData[this.propertyName] = this.rawPostalCode

        Promise.race([
          this.$store.dispatch('updatePostalCode', {
            postalCode: this.postalCode,
            storeKey: this.storeKey,
            propertyName: this.propertyName,
            country: this.app.country.code
          }),
          new Promise((resolve, reject) => {
            setTimeout(reject, 10000, new Error('time out'))
          })
        ]).then(() => {
          if (this.postalArea.cities && this.postalArea.cities.length === 1) {
            const propertyCity = property.length > 1 ? property.slice(0, -1).join('.') + '.city' : 'city'
            dispatchData[propertyCity] = this.postalArea.cities[0].value
          }

          if (this.postalArea.streets && this.postalArea.streets.length === 1) {
            const propertyStreetName = property.length > 1 ? property.slice(0, -1).join('.') + '.streetName' : 'streetName'
            dispatchData[propertyStreetName] = this.postalArea.streets[0].value
          }

          const propertyProvince = property.length > 1 ? property.slice(0, -1).join('.') + '.province' : 'province'
          const province = this.getProvince()
          if (province) {
            dispatchData[propertyProvince] = province.name
            dispatchData[`${propertyProvince}Code`] = `${this.app.country.code}-${province.code}`
          }

          this.$store.dispatch(this.dispatchKey, dispatchData)
          this.trackPrefill('postalCode', this.postalCode)
          this.$store.dispatch('next', this.screenParams.nextScreenRoute)
        }).catch((e) => {
          this.$store.dispatch(this.dispatchKey, dispatchData)
          this.$store.commit('updateApp', {dropPostalCodeFetch: true})
          this.$store.dispatch('next', this.screenParams.nextScreenRoute)
        })
      },
      approvePostcode (forgot) {
        if (forgot) {
          this.postalCode = ''
          this.updateCountry()
          this.$store.dispatch('updatePostalCode', {
            postalCode: this.app.unknownPostcode,
            GeoPostalCode: this.GeoPostalCode
          })

          let dispatchData = {}
          dispatchData[this.propertyName] = this.app.unknownPostcode
          this.$store.dispatch(this.dispatchKey, dispatchData)
        }

        this.$store.dispatch('next', this.screenParams.nextScreenRoute)

        this.focusActiveInput()
      },
      getRegionFromPostcodeRange () {
        const postRangesCountries = ['US']
        if (postRangesCountries.includes(this.app.country.code)) {
          return this.app.country.provinces.find(province => {
            return province.postcodeRanges.find(range => this.postalCode >= range.min && this.postalCode <= range.max)
          }).name || null
        } else {
          return null
        }
      },
      fixCountry (country) {
        this.$store.dispatch('updateApp', {
          country: country
        })
      },
      updateCountry () {
        let property = this.propertyName.split('.')
        property = property.length > 1 ? property.slice(0, -1).join('.') + '.country' : 'country'
        const currentValue = getNestedProperty(this.$store.state[this.storeKey], property)

        if (!currentValue) {
          let dispatchData = {}
          dispatchData[property] = this.app.country.code

          return this.$store.dispatch(this.dispatchKey, dispatchData)
        }
      },
      openCountrySelect () {
        if (this.isCountryChangeAvailable) {
          this.toggleModal()
        }
      },
      showDelayedForgot () {
        if (this.canShowSpecificContent) {
          this.forgotTimeout = setTimeout(() => {
            this.askIfForgot = true
          }, 4000)
        }
      },
      toggleModal () {
        this.showCountryModal = !this.showCountryModal
      },
      postalCodeRequirements () {
        if (this.noCodeCountry) {
          this.syncPostalCode(null)
          this.customPlaceholder = 'Confirm country'
          this.noPostcodeEntry = true
          return
        }

        if (this.app.country.singlePostalCode) {
          this.syncPostalCode(this.app.country.singlePostalCode)
          this.noPostcodeEntry = true
          return
        }

        this.noPostcodeEntry = false
        this.customPlaceholder = null
        this.checkIfLetterPostalcode()
      },
      checkIfLetterPostalcode () {
        this.containsLetters = this.app.country ? !this.canShowSpecificContent || this.app.country.postalCodePattern.indexOf('A') !== -1 || this.app.country.postalCodePattern[0].indexOf('A') !== -1 : false
      },
      focusActiveInput () {
        let activeInput
        if (this.showOneLineAddress) {
          activeInput = this.$el.querySelector('#onelineaddress input')
        } else {
          activeInput = this.containsLetters ? this.$el.querySelector('#alphanumeric input') : this.$el.querySelector('#tel input')
        }
        activeInput.blur()
        if (activeInput && !this.noPostcodeEntry) {
          setSelection(activeInput, { start: 0, end: 0 })
        }
      },
      autofillPostalCode () {
        const hasNoPostalCode = !this.user.postalCode || this.user.postalCode === this.app.unknownPostcode
        const autofilledSameCountry = this.autofill.country === this.app.country.code

        if (hasNoPostalCode && autofilledSameCountry && this.autofill.postalCode) {
          this.syncPostalCode(this.autofill.postalCode)
        }
      },
      checkIfOneLineAddress () {
        this.showOneLineAddress = this.app.country.code && this.partner.oneInputAddressCountries && this.partner.oneInputAddressCountries.includes(this.app.country.code)
      },
      async selectCountry (country) {
        const countryCode = country.value

        this.showCountryModal = false

        await this.$store.dispatch('updateUser', {
          country: countryCode
        })

        this.$store.dispatch('updateApp', {
            country: countryCode
          })
      },
      sortAlphebetically (a, b) {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      },
      isRestrictedCountry (countryCode) {
        return this.partner.restrictedCountries ? this.partner.restrictedCountries.indexOf(countryCode) !== -1 : false
      },
      getProvince() {
        const provinceName = this.postalArea.provinces && this.postalArea.provinces.length === 1 ? this.postalArea.provinces[0].value : this.getRegionFromPostcodeRange()
        if (provinceName) {
          const { provinces: countryProvinces = [] } = this.app.country
          const provinceMatch = countryProvinces.find((province) => {
            return province.name === provinceName
          })
          if(provinceMatch) {
            return {
              code: provinceMatch.ISOCode ? provinceMatch.ISOCode.slice(-2) : '',
              name: provinceMatch.name || provinceName,
            }
          }
        }
        // Get province from city object
        const cityObj = this.postalArea.cities && this.postalArea.cities.length && this.postalArea.cities[0]
        if(cityObj.province && (cityObj.province.code || cityObj.province.name)) {
          return cityObj.province
        }
      },
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/PostalCode.vue